import AnalyticsV2 from './AnalyticsV2/Analytics';
import CreateOrEditChart from './AnalyticsV2/CustomAnalytics/CreateOrEditChart/CreateOrEditChart';
import ApprovalRequest from './ApprovalRequest/ApprovalRequest';
// Settings
import AuditHistory from './Settings/Audit/Audit';
import DeveloperHubIndex from './DeveloperHub/DeveloperHubIndex';
import DynamicContentManager from './DynamicContentManager/DynamicContentManager';
// Experience Canvas
import ExperienceOverview from './ExperienceCanvas/Overview/ExperienceOverview';
import FlowBuilder from './FlowBuilder/FlowBuilder';
import HomeIndex from './Home/HomeIndex';
import LocationManagement from './LocationManagement/Overview/LocationManagement';
import NoAccess from './NoAccess/NoAccess';
import NotFoundIndex from './NotFound/NotFoundIndex';
import RedirectIndex from './Redirect/RedirectIndex';
import TemplatedExperienceIndex from './TemplatedExperience/Index/TemplatedExperienceIndex';
import TemplatesLibrary from './TemplatedExperience/TemplatesLibrary/TemplatesLibrary';
import ThemeHub from './ThemeHub/ThemeHub';
import TouchpointEditor from './ExperienceCanvas/TouchpointEditor/TouchpointEditor';
import Zone from './Zones/Zone';
import Zones from './Zones/Zones';
import ZonesOnboarding from './Zones/ZonesOnboarding';
import MerchantPortal from './MerchantPortal/MerchantPortal';
import CreateMerchantOffer from './MerchantPortal/CreateMerchantOffer/CreateMerchantOffer';
import RegisterMerchant from './MerchantPortal/RegisterMerchant/RegisterMerchant';
import EditMerchant from './MerchantPortal/EditMerchant/EditMerchant';
import EditMerchantOffer from 'pages/MerchantPortal/EditMerchantOffer/EditMerchantOffer';
// ToDo: After the GET offer by id endpoint is fixed
// Use the following component which uses react-query to manage merchant offer state
// import EditMerchantOffer from 'pages/MerchantPortal/EditMerchantOffer/EditMerchantOfferWithOfferEndpoint';

export default {
  DeveloperHubIndex,
  ThemeHub,

  HomeIndex,
  RedirectIndex,
  TemplatedExperienceIndex,
  TemplatesLibrary,
  AnalyticsV2,
  CreateOrEditChart,
  LocationManagement,
  DynamicContentManager,
  FlowBuilder,
  ApprovalRequest,

  ExperienceOverview,
  TouchpointEditor,
  AuditHistory,
  Zone,
  Zones,
  ZonesOnboarding,

  MerchantPortal,
  RegisterMerchant,
  EditMerchant,
  CreateMerchantOffer,
  EditMerchantOffer,

  NoAccess,
  NotFoundIndex,
};
